import {convertImageToWebP} from '@/helpers/shadcn/utils';

/**
 * Builds the media upload metadata payload expected by media/upload APIs.
 * @param {object} metadata - metadata from convertImageToWebP
 * @returns {{mediaUploadMetadata: object[]}}
 */
export const buildMediaUploadMetadataPayload = (metadata) => ({
  mediaUploadMetadata: [
    {
      id: metadata.id,
      referenceEntity: metadata.referenceEntity,
      originalFileName: metadata.originalFileName,
      originalFormat: metadata.originalFormat,
      originalSize: metadata.originalSize,
      width: metadata.width,
      height: metadata.height,
      blobFileSize: metadata.blobFileSize,
      blobFormat: metadata.blobFormat
    }
  ]
});

/**
 * Converts an image to WebP and builds multipart FormData for media upload.
 * @param {File|Blob} file
 * @param {{entityType?: string}} [options]
 * @returns {Promise<{formData: FormData, webpFile: File, metadata: object}>}
 */
export const buildWebpImageUploadFormData = async (file, options = {}) => {
  const {entityType = 'rewards'} = options;
  const {webpFile, metadata} = await convertImageToWebP(file, {entityType});

  const formData = new FormData();
  formData.append('images', webpFile);
  formData.append(
    'metadata',
    JSON.stringify(buildMediaUploadMetadataPayload(metadata))
  );

  return {formData, webpFile, metadata};
};

/**
 * Extracts a CDN URL from common media upload response shapes.
 * @param {any} response
 * @returns {string}
 */
export const extractCdnUrlFromUploadResponse = (response) => {
  let list = [];
  if (Array.isArray(response)) {
    list = response;
  } else if (Array.isArray(response?.data)) {
    list = response.data;
  }
  const first = list[0];
  return (
    first?.media?.cdnUrl ||
    first?.cdnUrl ||
    first?.url ||
    response?.data?.cdnUrl ||
    response?.data?.url ||
    ''
  );
};
